import styles from "../index.module.css";
import { ChevronDown, ChevronUp } from "../Icons";
import Select, { components } from "react-select";
import React from "react";
import { min } from "moment";

const customStylesDarker = {
  menu: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: "var(--bg)",
    color: "var(--white)",
    border: "none",
    minWidth: "min(280px, 92vw)",
    maxWidth: "92vw",
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: "var(--bg)",
    border: "none",
    color: "var(--white)",
  }),
  placeholder: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: "var(--bg)",
    border: "none",

    color: "var(--light-gray)",
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: "var(--black)",
    fontSize: "14px",
    color: "var(--white)",
    border: "1px solid var(--gray)",
    borderRadius: "6px",
    height: "32px",
    minHeight: "32px",
    maxHeight: "32px",
    display: "flex",
    alignContent: "center",
    marginTop: "2px",
    minWidth: "120px",
    width: "auto",
  }),

  valueContainer: (provided: any, state: any) => ({
    ...provided,
    // padding: "0 6px",
    color: "var(--white)",
  }),
  input: (provided: any, state: any) => ({
    ...provided,
    margin: "0px",
    border: "none",
    color: "var(--white)",
  }),
  indicatorSeparator: (state: any) => ({
    display: "none",
  }),
  indicatorsContainer: (provided: any, state: any) => ({
    ...provided,
  }),

  singleValue: (provided: any, state: any) => ({
    ...provided,
    border: "none",
    color: "var(--white)",
  }),
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
};

export const ToolbarDropDown = (props: any) => {
  return (
    <Select
      isLoading={props.loading}
      id={props.id}
      menuPortalTarget={document.body}
      menuPosition={"fixed"}
      menuShouldScrollIntoView={false}
      styles={customStylesDarker}
      components={{
        DropdownIndicator,
        IndicatorSeparator: () => null,
        ...props.components,
      }}
      {...props}
      minW={"20px"}
    />
  );
};

const DropdownIndicator = (props: any) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        {props.selectProps.menuIsOpen ? (
          <ChevronUp fontSize={"24px"} />
        ) : (
          <ChevronDown fontSize={"24px"} />
        )}
      </components.DropdownIndicator>
    )
  );
};
